export default import.meta.ROLLDOWN_FILE_URL__I_MLmXS6WUpjwp1BkTZFA